// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YOCT","badges":"styles_badges__-P3_l"};